import Vue from 'vue'
import Vuex from 'vuex'

import ui from './modules/ui/index'
import { UsersAccess, token } from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ui,
    token,
    UsersAccess
  }
})
